var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPrdType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M66.775,81.177h-25.975c-2.546,0-4.618-2.072-4.618-4.618V39.618c0-2.546,2.072-4.618,4.618-4.618h25.975c2.546,0,4.618,2.072,4.618,4.618v36.942c0,2.546-2.072,4.618-4.618,4.618Zm-25.975-43.868c-1.273,0-2.309,1.035-2.309,2.309v36.942c0,1.273,1.035,2.309,2.309,2.309h25.975c1.273,0,2.309-1.035,2.309-2.309V39.618c0-1.273-1.035-2.309-2.309-2.309h-25.975Z",
    fill: "#47d5cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.889,50.008c-.224,0-.447-.065-.64-.194l-2.823-1.882-2.823,1.882c-.356,.235-.811,.258-1.185,.057-.375-.201-.61-.592-.61-1.018v-12.699c0-.638,.517-1.154,1.154-1.154h6.927c.638,0,1.154,.517,1.154,1.154v12.699c0,.426-.234,.817-.61,1.018-.17,.091-.358,.136-.545,.136Zm-3.463-4.618c.223,0,.446,.065,.64,.194l1.669,1.112v-9.387h-4.618v9.387l1.669-1.112c.194-.129,.417-.194,.64-.194Z",
    fill: "#47d5cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.264,81.177c-.638,0-1.154-.517-1.154-1.154V37.309c0-.638,.517-1.154,1.154-1.154s1.154,.517,1.154,1.154v42.714c0,.638-.517,1.154-1.154,1.154Z",
    fill: "#47d5cd"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M112.593,67.473h-41.953c-.683,0-1.232,.549-1.232,1.232v40.499c0,.007,.007,.014,.007,.02-.014,1.834-1.499,3.32-3.333,3.32s-3.34-1.499-3.34-3.34v-28.989c0-.676-.549-1.232-1.231-1.232s-1.232,.549-1.232,1.232v28.989c0,3.2,2.604,5.796,5.796,5.796h41.946c.027,0,.047-.014,.067-.014,3.166-.04,5.73-2.617,5.73-5.783v-40.499c.007-.683-.543-1.232-1.225-1.232h0Zm-1.225,17.308v24.423c0,1.834-1.499,3.333-3.347,3.333-.014,0-.02,.007-.034,.007h-37.188c.67-.943,1.071-2.094,1.071-3.34v-24.43c0-.014-.007-.02-.007-.027v-14.811h39.497v14.844h.007Z",
    fill: "#47d5cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.824,89.59h11.352c.683,0,1.232-.549,1.232-1.232v-11.352c0-.676-.55-1.232-1.232-1.232h-11.351c-.683,0-1.232,.549-1.232,1.232v11.352c0,.676,.549,1.232,1.232,1.232h0Zm1.225-11.352h8.888v8.888h-8.888v-8.888Z",
    fill: "#47d5cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.378,89.59h14.163c.683,0,1.232-.549,1.232-1.232,0-.014-.007-.027-.007-.04s.007-.027,.007-.04c0-.676-.549-1.232-1.232-1.232h-14.163c-.683,0-1.232,.549-1.232,1.232,0,.014,.007,.027,.007,.04s-.007,.027-.007,.04c.007,.676,.556,1.232,1.232,1.232Z",
    fill: "#47d5cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.378,78.237h14.163c.683,0,1.232-.549,1.232-1.232,0-.676-.549-1.232-1.232-1.232h-14.163c-.683,0-1.232,.549-1.232,1.232,.007,.683,.556,1.232,1.232,1.232h0Z",
    fill: "#47d5cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.378,83.913h14.163c.683,0,1.232-.549,1.232-1.232,0-.676-.549-1.232-1.232-1.232h-14.163c-.683,0-1.232,.549-1.232,1.232,.007,.676,.556,1.232,1.232,1.232Z",
    fill: "#47d5cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.824,95.264h29.718c.683,0,1.232-.549,1.232-1.232,0-.676-.549-1.232-1.232-1.232h-29.718c-.683,0-1.232,.549-1.232,1.232,0,.677,.549,1.232,1.232,1.232Z",
    fill: "#47d5cd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.824,100.935h29.718c.683,0,1.232-.549,1.232-1.232,0-.676-.549-1.232-1.232-1.232h-29.718c-.683,0-1.232,.549-1.232,1.232s.549,1.232,1.232,1.232Z",
    fill: "#47d5cd"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrdType);
export default __webpack_public_path__ + "static/media/prd_type.6c1c0c3be4a3ef5b5d6e56620e6f0da5.svg";
export { ForwardRef as ReactComponent };